<template lang="pug">
  .modal.is-active(key="modal-editar")

    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalAdjuntar"
      )
        upload-image(
          name="adjuntar_documento_importante",
          onlyWord="true",
          folder="documentos_firmar",
          @save="guardarAdjunto"
          @close="closeModalAdjuntar"
        )
          span(slot="title") Adjuntar archivo word
          span(slot="explanation") Adjunta el archivo word deseado
          i.fa.fa-file-word-o(slot="topIcon")
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalSeleccionarEmpleado"
      )
        seleccionar-empleado(
          :idDocumentoFirmar="+id"
          @close="closeModalSeleccionarEmpleado"
          @save="guardarSeleccion"
        )
          //- span(slot="title") ¿Desea enviar la solicitud?

    .modal-background(@click="closeModalAdd()")
    .card
      header.modal-card-head.display-flex
        p.flex-1
          span(v-if="id") Editar documento
          span(v-else) Crear documento
        span.icon.close(
            @click="$emit('close')"
          )
            i.fa.fa-close
      .card-content
        .title

          .display-flex
            .control.margin-bottom-10.flex-1
              p.margin-bottom-5 Orden
              input.input.w-90(
                type="number",
                v-model="orden"
                :disabled="isLoading"
              )

            .control.margin-bottom-10.text-center
              p.margin-bottom-5 Activo
              input.checkbox(
                type="checkbox",
                v-model="activo"
                :disabled="isLoading"
              )

          .control.margin-bottom-10
            p.margin-bottom-5 Descripcion
            input.input.w-300(
              type="text",
              v-model="descripcion"
              :disabled="isLoading"
            )



          .text-center

            template
              .mb-5.mt-5.adjunto(v-if="ruta")
                a.button.is-small(:href="ruta", target="_blank")
                  span.icon.is-small
                    i.fa.fa-paperclip.is-small
                  span Ver adjunto
                span.icon.color-red.margin-left-5.cursor-pointer(@click="ruta = ''", tittle="Borrar adjunto")
                  i.fa.fa-trash
              div(v-else)
                button.button.is-small.is-primary(@click="openModalAdjuntar")
                  span.icon.is-small
                    i.fa.fa-upload.is-small
                  span Adjuntar
            button.button.is-small.is-primary(@click="openModalSeleccionarEmpleado")
                span.icon.is-small
                  i.fa.fa-users.is-small
                span Asignar Empleados
      footer.card-footer
        a.card-footer-item.is-success(@click="guardar(false)")
          span(v-if="isSaving") Guardando...
          span(v-else) Guardar
        a.card-footer-item( @click="$emit('close')")
          strong Cancelar

</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
import ComponentSeleccionarEmpleado from './Component_Seleccionar_Empleado'
import UploadImage from './Component_Upload_Image'
export default {
  name: 'documentos_firmar_editar',
  components: {
    'seleccionar-empleado': ComponentSeleccionarEmpleado,
    'upload-image': UploadImage
  },
  props: ['id'],
  data () {
    return {
      orden                          : 100,
      descripcion                    : '',
      activo                         : true,
      ruta                           : '',
      isSaving                       : false,
      mostrarModalAdjuntar           : false,
      isLoading                      : false,
      mostrarModalSeleccionarEmpleado: false,
      initialSelectedEmployees       : []
    }
  },
  mounted () {
    var vm = this
    if (vm.id) {
      vm.fetch()
    }
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        id: vm.id
      }

      apiGet(vm, '/documentos-firmar/unico/', obj, function (data) {
        vm.orden       = data.data.orden
        vm.descripcion = data.data.descripcion
        vm.activo      = data.data.activo
        vm.ruta        = data.data.rutaSinLlenar
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardar (openAsignarEmpleado = false) {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        orden       : vm.orden,
        descripcion : vm.descripcion,
        activo      : vm.activo,
        ruta        : vm.ruta
      }

      if (vm.id) {
        obj.id        = vm.id
      }

      apiPost(vm, '/documentos-firmar', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        if (openAsignarEmpleado) {
          // vm.id = data.insertedId
          vm.$emit('changeId', data.insertedId)
          vm.$nextTick(() => {
            vm.$emit('refresh')
            vm.openModalSeleccionarEmpleado()
          })
        } else {
          vm.$emit('closeRefresh')
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    guardarAdjunto (fileSubido) {
      var vm = this
      vm.closeModalAdjuntar()
      vm.ruta = fileSubido.file.ruta
    },
    openModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = true
    },
    closeModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = false
    },
    emitClose () {
      this.$emit('close')
    },
    openModalSeleccionarEmpleado () {
      var vm = this
      if (vm.id) {
        this.mostrarModalSeleccionarEmpleado = true
        return
      }
      vm.guardar(true)
    },
    closeModalSeleccionarEmpleado () {
      this.mostrarModalSeleccionarEmpleado = false
    },
    guardarSeleccion (data) {
      this.initialSelectedEmployees = data.codigos
      this.closeModalSeleccionarEmpleado()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .adjunto
    display flex
    justify-content center
    align-items center
    margin-bottom 10px
  .solicitud-vacaciones
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    >*
      transition: all 0.5s;

    .contenedor-transaccion
      .fechas
        display flex
        justify-content center
        .control
          padding 10px

      .acciones
        display flex
        margin-top 10px
        .button
          flex 1
          margin 5px

  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0
      left: 42px;
</style>



// WEBPACK FOOTER //
// c_documentos_firmar_editar.vue?6d958368